import script from "./Navigate.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navigate.vue?vue&type=script&lang=ts&setup=true"

import "./Navigate.vue?vue&type=style&index=0&id=b6578ece&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6578ece"]])

export default __exports__